const {
  specialCharacterRegEx,
  numberRegEx,
  stringRegEx,
  fieldRegEx,
} = require("./regex")

function getWords(exp) {
  const onlyWords = exp
    .replace(fieldRegEx, " ")
    .replace(stringRegEx, " ")
    .replace(numberRegEx, " ")
    .replace(specialCharacterRegEx, " ")

  return onlyWords.split(" ").filter((el) => el !== "")
}

export default function isSafe(exp, safeWords = []) {
  const expWords = getWords(exp)
  return expWords.every((word) => safeWords.includes(word))
}
